/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

export function decimalPlaces(number) {
	if (Math.floor(number) === number) {
		return 0;
	}

	return number.toString().split('.')[1].length || 0;
}

export function decimalMultiply(a, b) {
	const powerOf10_a = 10 ** decimalPlaces(a);
	const powerOf10_b = 10 ** decimalPlaces(b);

	return (a * powerOf10_a * (b * powerOf10_b)) / (powerOf10_a * powerOf10_b);
}

export function decimalPlus(a, b) {
	const powerOf10 = 10 ** Math.max(decimalPlaces(a), decimalPlaces(b));

	return (a * powerOf10 + b * powerOf10) / powerOf10;
}
